import { Avatar, Box, Button, Typography, useTheme } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useAppThemeContext, useUserContext } from '../../../contexts';
import { authService } from '../../../services';
import { LogoutOutlined } from '@mui/icons-material';

export const UserMenu: React.FC = () => {
  const theme = useTheme();
  const { lgDown } = useAppThemeContext();
  const { userProfilePicture, userName, logout, isAuthenticated } = useUserContext();
  const navigate = useNavigate();

  const { data: user } = useQuery(
    ['user'],
    () => authService.getUserFromCookie(),
    { enabled: isAuthenticated }
  );

  return (
    <Box display='flex' alignItems='center' gap={1.5}>
      {!lgDown && (
        <Typography variant="body1" sx={{ fontWeight: 500, fontSize: '0.875rem' }}>
          Olá, <strong>{user?.firstName?.split(' ')[0] ?? userName?.split(' ')[0] ?? 'Usuário'}</strong>
        </Typography>
      )}
      
      <Button
        variant='text'
        sx={{ 
          padding: 0,
          minWidth: 0,
          '&:hover': {
            backgroundColor: 'transparent'
          }
        }}
        onClick={() => navigate('/profile')}
      >
        <Avatar
          src={userProfilePicture}
          slotProps={{ img: { loading: 'lazy' } }}
          sx={{ 
            height: 36, 
            width: 36,
            border: `2px solid ${theme.palette.primary.main}`,
            transition: 'all 0.2s ease',
            '&:hover': {
              transform: 'scale(1.05)',
              boxShadow: `0 0 0 3px ${theme.palette.mode === 'dark' ? 'rgba(236, 64, 122, 0.2)' : 'rgba(236, 64, 122, 0.15)'}`,
            }
          }}
        />
      </Button>

      <Button
        variant='text'
        onClick={logout}
        sx={{
          minWidth: 0,
          padding: 1,
          color: 'text.secondary',
          borderRadius: 2,
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: theme.palette.mode === 'dark'
              ? 'rgba(239, 68, 68, 0.1)'
              : 'rgba(239, 68, 68, 0.06)',
            color: '#ef4444',
          },
        }}
      >
        <LogoutOutlined sx={{ fontSize: '1.25rem' }} />
      </Button>
    </Box>
  );
};
